import { render, staticRenderFns } from "./PosPaywayFeeType.vue?vue&type=template&id=27b26f56&"
import script from "./PosPaywayFeeType.vue?vue&type=script&lang=js&"
export * from "./PosPaywayFeeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports